import { getDomainUrl } from 'core/utils';

export const companyPartsPath = () => '/company/parts';

const domainUrl = getDomainUrl();

export const partListPath = (query = '') =>
  `/part/list${query ? `?query=${encodeURIComponent(query)}` : ''}`;

export const oldPartPath = (partNumber: string, manufacturerName: string) =>
  `${domainUrl}/part_v2?number=${partNumber}&manufacturer=${manufacturerName}`;
export const oldPartsPath = (query = '') => `${domainUrl}/part_v2/search?q=${query}`;
export const oldManufacturersPath = () => `${domainUrl}/manufacturers/list`;
export const oldConfiguratorsPath = () => `${domainUrl}/configurator/list`;
export const oldElementsPath = () => `${domainUrl}/element/template/list`;
export const oldCompanyConfiguratorsPath = () => `${domainUrl}/bom/list/all`;
export const oldCompanyElementsPath = () => `${domainUrl}/element/template/list`;
